import React from 'react';
import ContainerTemplate from '../../widgets/template/Container';
import PermisosView from './PermisosView';
import * as ROUTES from '../../router/Routes';

const PermisosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.permisos}
      routes={[ROUTES.usuEntidades, ROUTES.panelUsuEntidades]}
    >
      <PermisosView />
    </ContainerTemplate>
  );
};

export default PermisosModule;
